export const serviceListData = [
  {
    id: 1,
    image: '/assets/images/services/serviceImg1.png',
    titleDetail: {
      upperTitle: 'Use Client-first',
      middleTitle: 'SMD’S',
      lowerTitle: 'WE HAVE BEST SOLUTIONS FOR ALL',
    },
    desc:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.',
  },
  {
    id: 2,
    image: '/assets/images/services/serviceImg2.png',
    titleDetail: {
      upperTitle: 'Use Client-first',
      middleTitle: 'PHOTOGRAPHER',
      lowerTitle: 'WE HAVE BEST SOLUTIONS FOR ALL',
    },
    desc:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.',
  },
  {
    id: 3,
    image: '/assets/images/services/serviceImg3.png',
    titleDetail: {
      upperTitle: 'Use Client-first',
      middleTitle: 'cATERING',
      lowerTitle: 'WE HAVE BEST SOLUTIONS FOR ALL',
    },
    desc:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.',
  },
  {
    id: 4,
    image: '/assets/images/services/serviceImg4.png',
    titleDetail: {
      upperTitle: 'Use Client-first',
      middleTitle: 'Venues',
      lowerTitle: 'WE HAVE BEST SOLUTIONS FOR ALL',
    },
    desc:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.',
  },
  {
    id: 5,
    image: '/assets/images/services/serviceImg5.png',
    titleDetail: {
      upperTitle: 'Use Client-first',
      middleTitle: 'Printing',
      lowerTitle: 'WE HAVE BEST SOLUTIONS FOR ALL',
    },
    desc:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.',
  },
  {
    id: 6,
    image: '/assets/images/services/serviceImg6.png',
    titleDetail: {
      upperTitle: 'Use Client-first',
      middleTitle: 'Decor',
      lowerTitle: 'WE HAVE BEST SOLUTIONS FOR ALL',
    },
    desc:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.',
  },
  {
    id: 7,
    image: '/assets/images/services/serviceImg7.png',
    titleDetail: {
      upperTitle: 'Use Client-first',
      middleTitle: 'Styling',
      lowerTitle: 'WE HAVE BEST SOLUTIONS FOR ALL',
    },
    desc:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.',
  },
  {
    id: 8,
    image: '/assets/images/services/serviceImg8.png',
    titleDetail: {
      upperTitle: 'Use Client-first',
      middleTitle: 'aRTIST',
      lowerTitle: 'WE HAVE BEST SOLUTIONS FOR ALL',
    },
    desc:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.',
  },
];
